import { useEffect, useState } from "react";
import { get, post } from "../api";

interface Methods {
  google: boolean;
  dev_login: boolean;
}

// Every failure the callback can bounce back with. Mapped to plain language
// here rather than shown raw: "not_provisioned" is the one a person is most
// likely to hit and the one they can actually act on.
const REASONS: Record<string, string> = {
  denied: "Sign-in was cancelled.",
  expired: "That sign-in attempt timed out. Try again.",
  missing_code: "Google did not return a sign-in code. Try again.",
  state_mismatch: "That sign-in could not be verified. Try again.",
  exchange_failed: "Google rejected the sign-in. An admin should check the OAuth client.",
  not_provisioned:
    "Your Google account is valid, but you have no Sage account yet. Ask an admin to add you.",
  server_error: "Something went wrong signing you in.",
};

export default function Login() {
  const [methods, setMethods] = useState<Methods | null>(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reason = new URLSearchParams(window.location.search).get("error");

  useEffect(() => {
    void get<Methods>("/api/auth/methods").then(setMethods).catch(() => setMethods(null));
  }, []);

  const devLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await post("/api/auth/dev-login", { email });
      window.location.href = "/";
    } catch (err) {
      setError(err instanceof Error ? err.message : "failed");
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <div className="card">
        <h1>Sage</h1>
        <p className="sub">Customer conversations, summarised.</p>

        {reason && <div className="error">{REASONS[reason] ?? "Sign-in failed."}</div>}
        {error && <div className="error">{error}</div>}

        {methods?.google && (
          <a className="btn gbtn" href="/api/auth/google/start">
            Sign in with Google
          </a>
        )}

        {methods?.dev_login && (
          <div className="devbox">
            <h4>Local development only</h4>
            <form onSubmit={devLogin}>
              <div className="field">
                <label htmlFor="devemail">Sign in as</label>
                <input
                  id="devemail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="riddhi@arrowhead.team"
                  autoComplete="off"
                />
              </div>
              <button className="primary" disabled={busy || !email}>
                {busy ? "Signing in…" : "Sign in without Google"}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
